/**
 * Represents items in a parent-child hierarchy
 * @abstract
 */
class HierarchyItem {
	/**
	 * @member {?HierarchyItem} HierarchyItem#parent
	 * @private
	 */
	_parent = null;

	/** @member {?HierarchyItem} HierarchyItem#parent The parent of this item, set this to reparent items */
	get parent() {
		return this._parent;
	}

	set parent(parent) {
		if (parent && !(parent instanceof HierarchyItem))
			throw new TypeError('Expected parent to be of type HistoryItem');
		// remove item from previous parent
		if (this._parent) {
			const index = this._parent.children.indexOf(this);
			if (index === this._parent.children.length - 1) this._parent.children.pop();
			else this._parent.children[index] = this._parent.children.pop();
		}
		this._parent = parent;
		if (parent) {
			if (!parent.children) parent.children = [this];
			else parent.children.push(this);
		}
	}

	/**
	 * @member {?HierarchyItem[]} HierarchyItem#children
	 * @readonly
	 */
	children = null;

	/**
	 * Descends through all children recursively in a depth first fashion
	 * @method HierarchyItem#find
	 * @param {Function} finder called on each descendant of this node, descent is stopped when the finder returns true
	 * @param {Boolean} [one] if set to true all traversal ends as soon as the finder returns true
	 * @throws {TypeError} if given finder is not a function
	 * @return {Boolean} stopped returns true if the search was stopped by finder
	 */
	find(finder, one) {
		if (!(finder instanceof Function)) throw new TypeError('Expected finder to be a function');

		if (!this.children) return false;

		for (const child of this.children) {
			if (finder(child) === true) {
				if (one) return one;
				continue;
			}
			if (child.find(finder, one)) return one;
		}
		return false;
	}
}

export { HierarchyItem };
